module.exports = __webpack_public_path__ + "img/aghk-train-selected.68a0943a.svg";